import { createSlice } from "@reduxjs/toolkit";

export const createAssignmentWidgetSlice = ({ name, fetchThunk, defaultError }) =>
  createSlice({
    name,
    initialState: { data: null, isLoading: false, error: null },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(fetchThunk.pending, (state) => {
          state.isLoading = true;
          state.error = null;
        })
        .addCase(fetchThunk.fulfilled, (state, action) => {
          state.isLoading = false;
          state.data = action.payload;
        })
        .addCase(fetchThunk.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.error?.message ?? defaultError;
        });
    },
  });

export const createAssignmentSelectors = (stateKey) => ({
  selectData: (state) => state.proposals[stateKey].data,
  selectLoading: (state) => state.proposals[stateKey].isLoading,
  selectError: (state) => state.proposals[stateKey].error,
});
